<template>
  <section class="LoginPage Section">

    <aside class="LoginPage__aside">
      <p class="LoginPage__baseline">Le vin est un sujet trop sérieux<br /> pour le traiter en se prenant TROP au sérieux.</p>
      <img class="LoginPage__logo" src="../assets/images/logo.svg" alt="Logo CaptainVin" />
    </aside>
    <div class="LoginPage__content">

      <div v-if="displaySuccessMessage" class="message">
        <h1 class="PageTitle">Inscription en cours de validation</h1>
        <p>
          Encore un peu de patience, votre compte est en cours de validation par nos équipes.<br />
          Vous serez avertis par mail de sa création, dans les plus brefs délais.<br /><br />
          A bientôt.
        </p>
      </div>

      <form v-else @submit.prevent="signup" class="LoginForm">
        <h1 class="PageTitle">Demande d'inscription</h1>
        <div class="InputGroup">
          <label class="InputGroup__label">Nom de société</label>
          <Input :required="true" v-model="name" name="name" />
        </div>
        <div class="InputGroup">
          <label class="InputGroup__label">Siret</label>
          <Input :required="true" v-model="siret" name="siret" />
        </div>
        <div class="InputGroup">
          <label class="InputGroup__label">Email</label>
          <Input :required="true" autocomplete="email" v-model="email" name="email" />
        </div>
        <Button :loading="isLoading" class="Button Button--next" type="submit" data-cy="submit">Envoyer</Button>
        <div class="LoginPage__links">
          <router-link class="forgotten-password" data-cy="password-recovery" :to="{name: 'PasswordRecovery'}">Mot de passe oublié ?</router-link>
          <router-link class="forgotten-password" :to="{name: 'Login'}">J'ai déjà un compte</router-link>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import Input from "../components/Input";
import Button from "../components/Button";
import userService from "../services/user";
import notificationService from "../services/notification";

export default {
  data() {
    return {
      email: "",
      siret: "",
      name: "",
      displaySuccessMessage: false,
      isLoading: false
    };
  },
  methods: {
    signup: function() {
      const email = this.email;
      const siret = this.siret;
      const name = this.name;

      this.isLoading = true;

      userService.signup({ email, siret, name })
        .then(() => this.displaySuccessMessage = true)
        .catch(err => notificationService.error(err.message, err.errors))
        .finally(() => this.isLoading = false);
    }
  },
  components: { Input, Button }
};
</script>

<style lang="scss" scoped>
@import '../assets/variables';
@import '../assets/login';

.message {
  margin-right: 50px;
  font-size: 1.125em;
  line-height: 1.3;
}
</style>
